const API = process.env.REACT_APP_BACKEND_URL;
const DEFAULT = {
  title: "L'Œil du Marchand — Audit immobilier",
  manifest: '/manifest.json',
  themeColor: '#0A192F',
  appleIcon: '/icons/icon-180.png',
  favicon: '/favicon.ico',
};

const setLink = (rel, href) => {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) { el = document.createElement('link'); el.setAttribute('rel', rel); document.head.appendChild(el); }
  el.setAttribute('href', href);
};

const setMeta = (name, content) => {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) { el = document.createElement('meta'); el.setAttribute('name', name); document.head.appendChild(el); }
  el.setAttribute('content', content);
};

// Bascule le manifest / icônes / couleur sur la marque du partenaire (ou retour à la marque par défaut)
export const applyPwaBranding = (subdomain, info) => {
  if (subdomain && info) {
    const sub = subdomain.toLowerCase();
    const hasLogo = !!info.logo_url;
    setLink('manifest', `${API}/api/pwa/manifest/${sub}`);
    setLink('apple-touch-icon', hasLogo ? `${API}/api/pwa/icon/${sub}/180` : DEFAULT.appleIcon);
    setLink('icon', hasLogo ? `${API}/api/pwa/icon/${sub}/96` : DEFAULT.favicon);
    setMeta('theme-color', info.primary_color || DEFAULT.themeColor);
    setMeta('apple-mobile-web-app-title', info.name || DEFAULT.title);
    document.title = info.name ? `${info.name} — Audit immobilier` : DEFAULT.title;
    return;
  }
  setLink('manifest', DEFAULT.manifest);
  setLink('apple-touch-icon', DEFAULT.appleIcon);
  setLink('icon', DEFAULT.favicon);
  setMeta('theme-color', DEFAULT.themeColor);
  setMeta('apple-mobile-web-app-title', 'Œil du Marchand');
  document.title = DEFAULT.title;
};

export const registerServiceWorker = () => {
  if (!('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
};

export const isStandalone = () =>
  window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

export const isIos = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;
